import Phaser from 'phaser';

/**
 * Телепорт между биомами. Визуально отличается от портала-зеркала: вертикальный
 * вихрь из колец, медленная пульсация. При перекрытии с игроком сцена начинает
 * переход в целевой биом.
 *
 * Размещается на полу (origin внизу). Триггерная зона — overlap с body внизу
 * визуального вихря.
 */
export class Teleport extends Phaser.Physics.Arcade.Sprite {
  public readonly target: 'biome1' | 'biome2';
  private ringTween?: Phaser.Tweens.Tween;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    target: 'biome1' | 'biome2',
  ) {
    super(scene, x, y, 'teleport');
    this.target = target;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setOrigin(0.5, 1); // нижний край привязан к полу

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setAllowGravity(false);
    body.setImmovable(true);
    // Триггер-зона уже визуального вихря (он ~110×170, body 60×140 в центре)
    body.setSize(60, 140);
    body.setOffset((this.width - 60) / 2, this.height - 140);

    // Лёгкая пульсация alpha — видно что портал «живой»
    this.ringTween = scene.tweens.add({
      targets: this,
      alpha: 0.7,
      duration: 1100,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });
  }

  override destroy(fromScene?: boolean) {
    if (this.ringTween) {
      this.ringTween.stop();
      this.ringTween = undefined;
    }
    super.destroy(fromScene);
  }
}
